import React from 'react';

export default function GridBackground({
  size = 60,
  divisions = 30,
  distance = 20,
  color = '#666666',
}) {
  const grid = [color, color];

  return (
    <group>
      {/* Boden & Decke */}
      <gridHelper args={[size, divisions, ...grid]} position={[0, -distance, 0]} />
      <gridHelper args={[size, divisions, ...grid]} position={[0, distance, 0]} />
      {/* Rückwand & Vorderwand */}
      <gridHelper args={[size, divisions, ...grid]} position={[0, 0, -distance]} rotation={[Math.PI / 2, 0, 0]} />
      <gridHelper args={[size, divisions, ...grid]} position={[0, 0, distance]} rotation={[Math.PI / 2, 0, 0]} />
      {/* linke & rechte Wand */}
      <gridHelper args={[size, divisions, ...grid]} position={[-distance, 0, 0]} rotation={[0, 0, Math.PI / 2]} />
      <gridHelper args={[size, divisions, ...grid]} position={[distance, 0, 0]} rotation={[0, 0, Math.PI / 2]} />
    </group>
  );
}
